export const OPTMIZELY_GRAPHQL_BASE_URL = 'https://cg.optimizely.com/content/v2?auth=';
export const getApiHostname = () => {
    const currentHost = window.location.host;
    const isFED = currentHost.includes('localhost:3000') || currentHost.includes('luminary.space');
    return isFED ? 'https://qa-anzca-094930.xperience-sites.com' : '';
};
export const DEFAULT_FETCH_PARAMS = { headers: { 'Content-Type': 'application/json' } };
